import { LibertifyLogo } from "./icons";
import { SVGAttributes } from "react";

export const AppLogo = (props: SVGAttributes<SVGElement>) => {
  return <LibertifyLogo {...props} />;
};
